import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/defaultSettings.scss'
import './styles/main_style.scss'
import './index.css';
import App from './App';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import * as serviceWorker from './serviceWorker';
import reportWebVitals from './reportWebVitals';
import ScrollToTop from './components/ScrollToTop';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
  <ScrollToTop />
    <Routes>
    <Route path ="/*" element={<App/>}/>
    </Routes>
  </BrowserRouter>
);


serviceWorker.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
